import { playSound } from '@saaga/shared/utils/play-sound.util'

const MESSAGE_SOUND_URL = `${import.meta.env.BASE_URL}sound/message.mp3`

/**
 * Plays the message notification sound.
 * Used for both outgoing (user send) and incoming (assistant complete) messages.
 */
export const playMessageSound = (): void => {
  playSound(MESSAGE_SOUND_URL)
}
